// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../store-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rounded-xl{border-radius:1.25rem!important}.d-flex.items-flex-grow>*{flex-basis:0;flex-grow:1;max-width:100%}", ""]);
// Exports
module.exports = exports;
